module.exports = __webpack_public_path__ + "20204333e79d952f3b3aab3d36d6a0fa.svg";